import React from 'react';
import GLink from 'src/components/GLink';
import HeroSection from 'src/components/global/HeroSection';
import JoinNowSection from 'src/components/global/JoinNowSection';

const MarketMakerView = () => {
  return (
    <>
      <HeroSection pageTitle={'Market Maker Bot'} uris={['Products', 'Market Maker']} />
      <div className="page-content">
        <section style={{ backgroundColor: 'rgba(255, 215, 37, 0.02)' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <img className="rounded img-fluid mb-4" src="/images/blog/large/mm.png" alt="mm" />
                <div>
                  <GLink href="#" className="text-body">
                    <i className="bi bi-calendar3 me-1"></i> 3 Nov, 2022
                  </GLink>
                </div>
                <h2 className="my-3">
                  Liquidity Provider and <span className="text-gradient fw-700">rebates</span> buster.
                </h2>
                <p className="mb-4 lead">
                  Whatever you need, provide liquidity to your favourite token or take advantage of the rebates fees
                  distributed at your favourite exchange, the Market Maker bot is what you need.
                </p>

                <div className="mb-4">
                  <h5>The bad news</h5>
                  <p className="mb-0">It Is Not for Sale.</p>
                </div>
                <div className="mb-5">
                  <h5>The good news</h5>
                  <p className="mb-0">
                    You Can Have it as an Upgrade All You Have to do is Load Your Gunthy Wallet and it will Unlock the
                    Feature so you can Profit with the Market Maker bot: ask your reseller for more details.
                  </p>
                </div>
                <blockquote
                  className="blockquote border-start border-primary p-5 text-white mb-5"
                  style={{ backgroundColor: 'rgba(30, 80, 255, 0.02)' }}
                >
                  <p>
                    Whenever another trading bot thinks about a new feature, Gunbot users are already testing it since a
                    while.
                  </p>
                  <div className="blockquote-footer text-primary mt-2">Gunthar De Niro</div>
                </blockquote>

                <div className="d-md-flex justify-content-between border-top border-bottom border-dark py-4">
                  <div className="d-flex align-items-center">
                    <h6 className="mb-0 me-4">Share It:</h6>
                    <div className="social-icons">
                      <ul className="list-inline mb-0">
                        <li>
                          <GLink href="#">
                            <i className="bi bi-facebook"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-dribbble"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-instagram"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-twitter"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-linkedin"></i>
                          </GLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-flex align-items-center text-md-end mt-5 mt-md-0">
                    <h6 className="mb-0 me-4">Tags: </h6>
                    <ul className="list-inline mb-0 widget-tags">
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Bitcoin
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Market Makers
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Trading
                        </GLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <JoinNowSection />
      </div>
    </>
  );
};

export default MarketMakerView;
